import { useCallback, useEffect, useState } from 'react';

export const useIntersection = (
  {
    root = null,
    rootMargin = '0px',
    threshold = 1,
  }: IntersectionObserverInit = { root: null, rootMargin: '0px', threshold: 1 },
) => {
  const [intersection, setIntersection] =
    useState<IntersectionObserverEntry | null>(null);

  const [element, setElement] = useState<HTMLElement | null>(null);

  const capturingIntersectionElement = useCallback(
    (element: HTMLElement | null) => {
      if (element) {
        setElement(element);
      }
    },
    [],
  );

  useEffect((): (() => void) | undefined => {
    if (element == null || typeof IntersectionObserver !== 'function')
      return undefined;

    const handler = (entries: IntersectionObserverEntry[]) => {
      setIntersection(entries[0]);
    };
    const observer = new IntersectionObserver(handler, {
      root,
      rootMargin,
      threshold,
    });
    observer.observe(element);

    return () => {
      setIntersection(null);
      observer.disconnect();
    };
  }, [element, root, rootMargin, threshold]);

  return { capturingIntersectionElement, element, intersection };
};
